import React, { useState } from "react";
import Image from "next/image";
import Carousel from "@/components/ui/carousel/carousel";
import { SwiperSlide } from "swiper/react";
import KnowMore from "@/components/ui/know-more";
import SubscribeButton from "@/components/ui/subscribe-button";
import Link from "next/link";
export default function RelatedPosts({
  data = [],
  title,
  description,
  showNavAbove = false,
  showButton,
  buttonLink,
  buttonText = "view more",
  showSubscribe,
}) {
  const breakpoints = {
    1280: {
      slidesPerView: 2.4,
      spaceBetween: 30,
      slidesOffsetBefore: 32,
    },
    991: {
      slidesPerView: 2.2,
      spaceBetween: 20,
      slidesOffsetBefore: 32,
    },
    // when window width is >= 768px
    768: {
      slidesPerView: 1.4,
      spaceBetween: 20,
      slidesOffsetBefore: 32,
    },
    325: {
      slidesPerView: 1.1,
      spaceBetween: 15,
      slidesOffsetBefore: 16,
      slidesOffsetAfter: 16,
    },
  };

  return (
    <div className="bg-[#F2F0E9] py-16 z-[100] relative ">
      <div className="flex flex-col w-full">
        <Carousel
          slidesPerView={2.4}
          spaceBetween={30}
          loop={false}
          className="featureCarousel w-full my-8"
          breakpoints={breakpoints}
          navigation={false}
          autoplay={{
            delay: 4500,
            disableOnInteraction: false,
          }}
          pagination={false}
          showNavAbove={showNavAbove}
          title={title}
          description={description}

          // slidesOffsetAfter={20}
        >
          {data.map((post, key) => (
            <SwiperSlide key={"Post" + key}>
              <Post data={post} />
            </SwiperSlide>
          ))}
        </Carousel>
        {showButton && (
          <KnowMore path={buttonLink ?? "#"} className="mx-auto mt-12 ">
            {buttonText}
          </KnowMore>
        )}
      </div>
      {showSubscribe && (
        <div className="mt-12">
          <SubscribeButton />
        </div>
      )}
    </div>
  );
}
export const Post = ({ data }) => {
 // console.log(data);
  const { title, coverImage, excercpt, slug, blog_categories } = data;
  return (
    <Link className="flex flex-col w-full" href={`/blog-${slug}`}>
      <div
        className={`flex items-start justify-start relative w-full lg:h-[30vw] md:h-[426px] h-[308px] overflow-hidden mb-4`}
      >
        <Image
          src={
            coverImage?.data?.attributes?.formats?.medium?.url ??
            coverImage?.data?.attributes?.formats?.large?.url ??
            coverImage?.data?.attributes?.url ??
            "/images/placeholder.svg"
          }
          alt={coverImage?.data?.attributes?.name ?? "blog-image"}
          sizes="(max-width: 479px) 500px, 100vw"
          fill
          className="w-full h-full object-cover"
        />
      </div>

      <p className="text-sm text-[#121111]/60 mb-0">{`${blog_categories?.data[0]?.attributes.name} | By Admin`}</p>
      <p className="text-[#121111]/90 md:text-[20px] mt-1 text-base">{title}</p>
    </Link>
  );
};
